import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { useHotelApplicationDataQuery } from "@/components/features/_shared/repository/hotel-application-data/query";

import { RESERVATION_DETAIL_FOR_MANAGEMENT_RESERVATION_ITEM_QUERY } from "../../../../_shared/model/repository/query";

export const useReservationDetailForManagementReservationItemQuery = (hotelID: string, reservationId: string) => {
	const { data } = useCustomSuspenseQuery(RESERVATION_DETAIL_FOR_MANAGEMENT_RESERVATION_ITEM_QUERY, {
		variables: {
			hotelID,
			reservationId,
		},
		fetchPolicy: "network-only",
	});

	const { hotelApplicationData } = useHotelApplicationDataQuery(hotelID);

	return {
		reservationDetailForManagementReservationItemServerModel: data,
		isHostDirectReservationAvailable:
			hotelApplicationData?.hotelApplicationStatus.isHostDirectReservationAvailable || false,
	};
};
